import {Column, HeaderProps} from 'react-table'
import {CustomHeader} from '../../../utils/components/Table/CustomHeader'
import {dateFormat} from '../../../utils/helperFunction/_helper'
import {PropsWithChildren} from 'react'
import SenderIdAction from './SenderIdAction'
import {ISenderId} from '../core/_model'
import SenderDefault from './SenderDefault'
import SelectionHeader from '../../../utils/components/Table/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/Table/SelectionCell'
import SenderStatusCell from './SenderStatusCell'
import SenderCell from './SenderCell'
import RouteCell from './RouteCell'

const senderIdsColumns = (profileid: number): ReadonlyArray<Column<ISenderId>> => {
  const cols: Column<ISenderId>[] = [
    {
      Header: (props) => <SelectionHeader tableProps={props as any} context={ListViewContext} />,
      id: 'selection',
      Cell: ({...props}) => (
        <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
      ),
    },
    {
      Header: (props) => <CustomHeader tableProps={props} title='Sender' className='min-w-125px' />,
      id: 'sender',
      accessor: 'sender',
      Cell: ({...props}) => <SenderCell sender={props.data[props.row.index]} />,
    },
    {
      Header: (props) => (
        <CustomHeader tableProps={props} title='route name' className='min-w-125px' />
      ),
      id: 'routeName',
      accessor: 'routeName',
      Cell: ({...props}) => (
        <RouteCell
          routeName={props.data[props.row.index].routeName}
          aggregatorName={props.data[props.row.index].aggregatorName}
        />
      ),
    },
    // {
    //   Header: (props: PropsWithChildren<HeaderProps<ISenderId>>) => (
    //     <CustomHeader tableProps={props} title='Type' className='min-w-125px' />
    //   ),
    //   accessor: 'branded',
    //   Cell: ({...props}) => <p>{brandDefine(props.data[props.row.index].branded)}</p>,
    // },
    {
      Header: (props: PropsWithChildren<HeaderProps<ISenderId>>) => (
        <CustomHeader tableProps={props} title='Insert Date' className='min-w-125px' />
      ),
      id: 'insertdate',
      accessor: 'insertdate',
      Cell: ({...props}) => <p>{dateFormat(props.data[props.row.index].insertdate, true)}</p>,
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<ISenderId>>) => (
        <CustomHeader tableProps={props} title='Update Date' className='min-w-125px' />
      ),
      id: 'updatedat',
      accessor: 'updatedat',
      Cell: ({...props}) => (
        <p>
          {props.data[props.row.index].updatedat
            ? dateFormat(props.data[props.row.index].updatedat, true)
            : 'N/A'}
        </p>
      ),
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<ISenderId>>) => (
        <CustomHeader tableProps={props} title='status' className='min-w-125px' />
      ),
      id: 'status',
      Cell: ({...props}) => <SenderStatusCell status={props.data[props.row.index].senderStatus} />,
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<ISenderId>>) => (
        <CustomHeader tableProps={props} title='Default' className='min-w-100px' />
      ),
      id: 'default',
      Cell: ({...props}) => <SenderDefault sender={props.data[props.row.index]} />,
    },
    {
      Header: (props: PropsWithChildren<HeaderProps<ISenderId>>) => (
        <CustomHeader tableProps={props} title='Actions' className='min-w-100px text-end' />
      ),
      id: 'actions',
      Cell: ({...props}) => <SenderIdAction sender={props.data[props.row.index]} />,
    },
  ]

  //   if (profileid !== 1) {
  //     cols.pop()
  //   }

  if (profileid !== 2) {
    cols.pop()
  }

  return cols
}

export {senderIdsColumns}
